import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useIoxAddOnByDeviceIds(deviceIds: string[]) {
  const queryClient = useQueryClient();

  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["ioxAddOn", activeSessionId, deviceIds],

    queryFn: async ({ signal }) => {
      const res: Record<string, number | null> = {};

      if (!deviceIds) {
        return Promise.resolve(res);
      }

      await Promise.all(
        deviceIds.map(async id => {
          try {
            const data = await geotabClient.get(
              "IoxAddOn",
              { deviceSearch: { id }, type: 4200 },
              1,
              signal,
            );

            if (data.length === 0) {
              res[id] = null;

              queryClient.setQueryData(["ioxAddOn", activeSessionId, id], null);
            } else {
              res[id] = data[0].channel;
              queryClient.setQueryData(["ioxAddOn", activeSessionId, id], data[0].channel);
            }
          } catch (error) {
            console.error("Fehler beim Abrufen der IoxAddOn-Daten für die ID:", id, error);
            res[id] = null;
            queryClient.setQueryData(["ioxAddOn", id], null);
          }
        }),
      );

      return res;
    }
  });
}
